import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import CustomDropDownList from "ui/dropDown";
import { PurchaseOverviewFilter } from "api/sales";
import { getBuyersFilterApi } from "api/common";
import { CustomNumberInput } from "ui/Input";
import { Vessel } from "interface/vessel";
import { getVesselFilter } from "api/vessel";
import VesselRenderItem from "ui/dropdownItemList/VesselRenderItem";

interface CustomProps {
	pageSize: number;
	setFilterOptions: (options: PurchaseOverviewFilter) => void;
	filterOptions: PurchaseOverviewFilter;
	exportAsPDF: () => void;
	exportAsExcel: () => void;
}
const Filter: FC<CustomProps> = ({
	setFilterOptions,
	filterOptions,
	exportAsPDF,
	...props
}) => {
	const { t } = useTranslation();
	const [tempFilter, setTempFilter] = useState<PurchaseOverviewFilter>();

	const applyAuctionNumber = () => {
		setFilterOptions({
			...filterOptions,
			auctionNumber: tempFilter?.auctionNumber || "",
			take: props.pageSize,
			skip: 0,
		});
	};
	const applySalesNumber = () => {
		setFilterOptions({
			...filterOptions,
			salesNumber: tempFilter?.salesNumber || "",
			take: props.pageSize,
			skip: 0,
		});
	};

	const applyContractNumber = () => {
		setFilterOptions({
			...filterOptions,
			contractNumber: tempFilter?.contractNumber || "",
			take: props.pageSize,
			skip: 0,
		});
	};
	return (
		<div className="filter-container">
			<div className="filter-items purchase-overview-filter-items">
				<div className="purchase-overview-filter-field">
					<CustomDropDownList
						onSelect={(buyer) =>
							setFilterOptions({
								...filterOptions,
								buyerId: buyer.id,
								buyerName: buyer.name,
								buyerLedgerAccountNumber: buyer.id,
								take: props.pageSize,
								skip: 0,
							})
						}
						data={[]}
						value={{
							id: filterOptions.buyerId || null,
							//	name: filterOptions.buyerName || t("ChooseBuyer"),
							name: filterOptions.buyerName || " ",
						}}
						dataItemKey="id"
						textField="name"
						label={t("Buyer")}
						defaultItem={{ id: null, name: t("All") }}
						className="height-inherit"
						filterable={true}
						serverFilter={true}
						serverFilterApi={getBuyersFilterApi}
					/>
				</div>

				<div className="annual-statement-filter-field" style={{ width: "170px" }}>
					<CustomDropDownList
						data={[]}
						filterable={true}
						dataItemKey="id"
						textField="nm"
						label={t("Vessel")}
						itemRender={VesselRenderItem}
						value={{
							id: filterOptions.vesselId || null,
							//	nm: filterOptions.vesselName || t("ChooseVessel"),
							nm: filterOptions.vesselName || " ",
						}}
						// label="Velg Fart�y"
						defaultItem={{ id: null, nm: t("All") }}
						onSelect={(vessel: Vessel) => {
							setFilterOptions({
								...filterOptions,
								vesselId: vessel.id,
								vesselName: vessel.id ? vessel.nm : "",
								vesselLedgerAccountNumber: vessel.res as any,
								take: props.pageSize,
								skip: 0,
							});
						}}
						serverFilter={true}
						serverFilterApi={getVesselFilter}
						popupSettings={{ width: 400 }}
					/>
				</div>


				<div className="purchase-overview-filter-field">
					<CustomNumberInput
						onChange={(e) => setTempFilter({ ...tempFilter, salesNumber: e })}
						label={t("SalesNumber")}
						placeholder=" "
						className="height-inherit"
						spinners={false}
						value={tempFilter?.salesNumber}
						onKeyDown={(e: any) => {
							if (e.key === "Enter") {
								applySalesNumber();
							}
						}}
						onBlur={(e) => {
							applySalesNumber();
						}}
					/>
				</div>
				<div className="purchase-overview-filter-field">
					<CustomNumberInput
						onChange={(e) => setTempFilter({ ...tempFilter, auctionNumber: e })}
						label={t("AuctionNumber")}
						placeholder=" "
						className="height-inherit"
						value={tempFilter?.auctionNumber}
						onKeyDown={(e: any) => {
							if (e.key === "Enter") applyAuctionNumber();
						}}
						onBlur={(e) => applyAuctionNumber()}
						spinners={false}
					/>
				</div>
				<div className="purchase-overview-filter-field">
					<CustomNumberInput
						onChange={(e) =>
							setTempFilter({ ...tempFilter, contractNumber: e })
						}
						label={t("ContractNumber")}
						placeholder=" "
						className="height-inherit"
						value={tempFilter?.contractNumber}
						onKeyDown={(e: any) => {
							if (e.key === "Enter") applyContractNumber();
						}}
						onBlur={(e) => applyContractNumber()}
						spinners={false}
					/>
				</div>
			</div>

			<div className="filter-end-btn purchase-overview-filter-end-btn">
				{/*<CustomButton*/}
				{/*	label={"PDF"}*/}
				{/*	onClick={() => exportAsPDF()}*/}
				{/*	iconName={ICON_NAMES.Download}*/}
				{/*/>*/}
				{/*	<CustomButton*/}
				{/*		label={"Excel"}*/}
				{/*		onClick={() => props.exportAsExcel()}*/}
				{/*		iconName={ICON_NAMES.Download}*/}
				{/*	/>*/}
			</div>
		</div>
	);
};

export default Filter;
